// IUPAC nucleotide codes → the set of bases each represents (DNA alphabet).
export const IUPAC_BASES: Record<string, string> = {
  A: "A",
  C: "C",
  G: "G",
  T: "T",
  U: "T",
  R: "AG",
  Y: "CT",
  S: "GC",
  W: "AT",
  K: "GT",
  M: "AC",
  B: "CGT",
  D: "AGT",
  H: "ACT",
  V: "ACG",
  N: "ACGT",
};

// DNA complement, IUPAC-aware (complement of the base set).
export const DNA_COMPLEMENT: Record<string, string> = {
  A: "T",
  T: "A",
  U: "A",
  G: "C",
  C: "G",
  R: "Y",
  Y: "R",
  S: "S",
  W: "W",
  K: "M",
  M: "K",
  B: "V",
  V: "B",
  D: "H",
  H: "D",
  N: "N",
};

export function isIupacCode(ch: string): boolean {
  return ch.toUpperCase() in IUPAC_BASES;
}

/** Convert an IUPAC nucleotide motif to a regex character-class pattern. */
export function iupacToRegex(
  motif: string,
): { ok: true; pattern: string } | { ok: false; error: string } {
  let out = "";
  for (const raw of motif.trim()) {
    if (/\s/.test(raw)) continue;
    const ch = raw.toUpperCase();
    const bases = IUPAC_BASES[ch];
    if (!bases) return { ok: false, error: `Not an IUPAC code: ${raw}` };
    out += bases.length === 1 ? bases : `[${bases}]`;
  }
  if (!out) return { ok: false, error: "Enter an IUPAC nucleotide motif." };
  return { ok: true, pattern: out };
}
